import React from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { Switch, Radio, Divider } from "antd";
// import CameraSetting from "../../Pages/ByPanel/cameraSetting";

export default function Setting() {
  
  
  return (
    
    <Card>
    
      <CardHeader>صفحه تنظیمات</CardHeader>
      <CardBody>
      <Divider>تنظیمات کلی سایت</Divider>
        <Row>
          <Col>
            <Switch
              checkedChildren="فعال"
              unCheckedChildren="غیرفعال"
              defaultChecked
            />
          </Col>
        </Row>
        <Divider>تنظیمات ظاهری</Divider>
        <Row>
          <Col>
            <div>
              <strong>انتخاب تم سایت</strong>
            </div>
            <Radio.Group defaultValue="a" buttonStyle="solid">
              <Radio.Button className="dark-theme" value="a">تاریک</Radio.Button>
              <Radio.Button className="light-theme" value="b">روشن</Radio.Button>
              <Radio.Button className="standard-theme"  value="c">استاندارد</Radio.Button>
              
            </Radio.Group>
          </Col>
        </Row>
        <Divider>بخش عکس انداختن</Divider>
        
      </CardBody>
    </Card>
  );
}
